var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"50px","position":"fixed","top":"20px","left":"20px","width":"100%","display":"flex"},on:{"click":_vm.clickArrow}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrows"},[_c('img',{staticStyle:{"width":"40px","height":"40px"},attrs:{"src":require("../../assets/img/btn-icon-1.png")}})])
}]

export { render, staticRenderFns }